import { render, staticRenderFns } from "./NewPromotions.vue?vue&type=template&id=2db56957"
import script from "./NewPromotions.vue?vue&type=script&lang=js"
export * from "./NewPromotions.vue?vue&type=script&lang=js"
import style0 from "./NewPromotions.vue?vue&type=style&index=0&id=2db56957&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports